'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ugcSummaryShape = _reactImmutableProptypes2.default.contains({
  id: _react.PropTypes.number.isRequired,
  userId: _react.PropTypes.number.isRequired,
  metadataId: _react.PropTypes.string.isRequired,
  summary: _react.PropTypes.string.isRequired
});

exports.default = ugcSummaryShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/ugcSummaryShape.js
// module id = 388
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16